class HdmImageLightboxCaption {

  constructor () {
    this.overlay = document.querySelector('.wp-lightbox-overlay')
    this.captionEl = null
    this.pendingCaption = ''

    if (this.overlay) {
      this.overlay.classList.remove('zoom')

      document.addEventListener('click', (e) => {
        const figure = e.target.closest?.('figure.wp-lightbox-container')

        if (figure) {
          const caption = figure.querySelector(':scope > figcaption')
          this.pendingCaption = caption ? caption.innerHTML.trim() : ''
        }
      }, true)

      new MutationObserver(() => {
        if (this.overlay.classList.contains('active')) {
          this.showCaption()
        } else {
          this.hideCaption()
        }
      }).observe(this.overlay, { attributes: true, attributeFilter: ['class'] })
    }
  }

  showCaption () {
    if (!this.pendingCaption) {
      this.hideCaption()
      return
    }

    if (!this.captionEl) {
      this.captionEl = document.createElement('figcaption')
      this.captionEl.className = 'hdm-lightbox-caption'
    }

    this.captionEl.innerHTML = this.pendingCaption

    if (this.captionEl.parentNode !== this.overlay) {
      this.overlay.appendChild(this.captionEl)
    }
  }

  hideCaption () {
    if (this.captionEl && this.captionEl.parentNode) {
      this.captionEl.parentNode.removeChild(this.captionEl)
    }
  }

}

window.addEventListener('DOMContentLoaded', () => {
  window.hdmImageLightboxCaption = new HdmImageLightboxCaption()
})